import { render, staticRenderFns } from "./labelselect.vue?vue&type=template&id=8da82d2c&scoped=true"
import script from "./labelselect.vue?vue&type=script&lang=js"
export * from "./labelselect.vue?vue&type=script&lang=js"
import style0 from "./labelselect.vue?vue&type=style&index=0&id=8da82d2c&prod&lang=scss&scoped=true"
import style1 from "./labelselect.vue?vue&type=style&index=1&id=8da82d2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8da82d2c",
  null
  
)

export default component.exports